import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  BESTSELLER_LIMIT,
  fetchBestsellers,
  fetchProducts,
  sortProductsAsBestsellers,
} from '../lib/products';
import { isSupabaseConfigured } from '../lib/supabaseClient';

export function useBestsellers(limit = BESTSELLER_LIMIT) {
  const { loading: authLoading } = useAuth();
  const [bestsellers, setBestsellers] = useState([]);
  const [loading, setLoading] = useState(isSupabaseConfigured);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isSupabaseConfigured) {
      setLoading(false);
      return undefined;
    }

    if (authLoading) {
      return undefined;
    }

    let cancelled = false;

    async function loadBestsellers() {
      setLoading(true);
      setError('');

      try {
        let data;

        try {
          data = await fetchBestsellers(limit);
        } catch {
          const products = await fetchProducts();
          data = sortProductsAsBestsellers(products, limit);
        }

        if (!cancelled) {
          setBestsellers(data);
        }
      } catch (loadError) {
        if (!cancelled) {
          setBestsellers([]);
          setError(
            loadError.message?.includes('permission')
              ? 'Bestsellers are not visible. Run supabase-bestsellers.sql in Supabase.'
              : 'Could not load bestsellers.'
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadBestsellers();

    return () => {
      cancelled = true;
    };
  }, [authLoading, limit]);

  return { bestsellers, loading, error };
}
